import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import Footer from "./Footer";
import HeadingNavbar from "./HeadingNavbar";
import Header from "./Header";
import { Helmet } from "react-helmet";

const BillingAndShippingPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Billing & Shipping Policy | Bliss Water Technology</title>
        <meta
          name="description"
          content="Shipping and billing policy of Bliss Water Technology for water filters, geysers, pumps, and membranes in Gujarat. Delivery and installation included."
        />
        <meta
          name="keywords"
          content="Shipping policy Gujarat, water filter delivery Gujarat, geyser installation, pump service Gujarat, membrane delivery, Bliss Water billing"
        />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <HeadingNavbar />
      <Header />
      <Container>
        <Row className="my-md-5 my-4">
          <Col>
            <Card.Title className="text-center fs-2 mb-3 fw-bold">
              Billing & Shipping Policy
            </Card.Title>
            <Card>
              <Card.Body>
                <Card.Text as="div">
                  <section>
                    <h5 className="fw-bold">Service Area</h5>
                    <p>
                      Bliss Water Technology provides delivery, installation,
                      and service exclusively within the state of{" "}
                      <strong>Gujarat, India</strong>. We do not currently
                      deliver to other states or internationally.
                    </p>
                  </section>

                  <section>
                    <h5 className="fw-bold">Shipping Policy</h5>
                    <p>
                      Free shipping is available on all orders above ₹500 within
                      Gujarat. For smaller orders, a nominal delivery fee may be
                      applicable and will be communicated in advance.
                    </p>
                  </section>

                  <section>
                    <h5 className="fw-bold">Delivery & Installation</h5>
                    <p>
                      Products such as water filters, geysers, pumps, and
                      membranes are delivered and installed by our authorized
                      technicians. Most orders are delivered within 5–7 business
                      days after confirmation.
                    </p>
                  </section>

                  <section>
                    <h5 className="fw-bold">Payment Method</h5>
                    <p>
                      We do not accept online payments. All payments must be
                      made directly to our delivery or installation agent after
                      the service is completed.
                    </p>
                  </section>

                  <section>
                    <h5 className="fw-bold">Packaging & Handling</h5>
                    <p>
                      All items are packaged securely for safe transport. If a
                      product arrives damaged, please notify us immediately for
                      a replacement.
                    </p>
                  </section>

                  <section>
                    <h5 className="fw-bold">Contact Us</h5>
                    <p>
                      For any shipping or billing-related queries, contact us at{" "}
                      <a href="mailto:blisswatertechnology@gmail.com">blisswatertechnology@gmail.com</a>{" "}
                      or call our support team at{" "}
                      <a href="tel:+919265199516">+91 92651 99516</a>. We're here to help!
                    </p>
                  </section>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <Footer />
    </>
  );
};

export default BillingAndShippingPolicy;
